import { S } from '../regureStyles';

const Tabs = ({ TABS, activeTab, setActiveTab }) => {
  return (
    <div style={{ display: 'flex', padding: '0 32px', borderBottom: `1px solid ${S.borderLight}`, background: 'rgba(255,255,255,0.6)' }}>
      {TABS.map(t => (
        <button
          key={t.id}
          onClick={() => setActiveTab(t.id)}
          style={{
            padding: '12px 20px',
            fontSize: 13,
            fontWeight: activeTab === t.id ? 600 : 500,
            color: activeTab === t.id ? S.burgundy : S.textMuted,
            background: 'none',
            border: 'none',
            borderBottom: activeTab === t.id ? `2px solid ${S.burgundy}` : '2px solid transparent',
            cursor: 'pointer',
            transition: 'all 0.15s',
            whiteSpace: 'nowrap',
          }}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
